//export class CryptoService {
//}

import { Injectable } from '@angular/core';
import  CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private secretKey: string = ''; // Replace with a secure key
  private Vector: string = '';  // Replace with a vector

 
  private secretKeynew: string = "A9fK2LmP8QxR7ZtE4WnC5D6JH0S1UBy"; // 32 chars
  private Vectornew: string = 'A1B2C3D4E5F6G7H8'; // 16 chars

  //will be used for decrypting
  //private secretKey: string = 'mysecure32characterlongsecretkey!!!'; // 32 characters
  //private Vector: string = 'my16bytevectoriv'; // 16 characters
  constructor() { }


  /*Added By Swapnali*/

  // Generate a random salt
  private generateSalt(): string {
    return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
  }

  // Generate a random IV
  private generateIV(): string {
    return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
  }

  //----


  encryptnew(value: string): string {

    const salt = this.generateSalt();  // Generate random salt
    const iv = this.generateIV();  // Generate random IV
    const key = CryptoJS.PBKDF2(this.secretKeynew, CryptoJS.enc.Hex.parse(salt), {
      keySize: 256 / 32,
      iterations: 1000
    });

    const encrypted = CryptoJS.AES.encrypt(value, key, {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

    // Return encrypted text along with salt and IV
    return `${salt}:${iv}:${encrypted}`;


    //return CryptoJS.AES.encrypt(value, this.secretKey, {
    //  iv: CryptoJS.enc.Utf8.parse(this.Vector),
    //  mode: CryptoJS.mode.CBC,
    //  padding: CryptoJS.pad.Pkcs7,

    //}).toString();
    //}
  }

  decrypt(encryptedText: string): string {
    const parts = encryptedText.split(':');  // Extract salt, IV, and encrypted value

    if (parts.length !== 3) {
      throw new Error('Invalid encrypted data format');
    }

    const salt = parts[0];
    const iv = parts[1];
    const encryptedData = parts[2];

    const key = CryptoJS.PBKDF2(this.secretKeynew, CryptoJS.enc.Hex.parse(salt), {
      keySize: 256 / 32,
      iterations: 1000
    });

    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptObject(value: any): string {
    return this.encryptnew(JSON.stringify(value));
  }


  ///For IA Profile

  encryptIA(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey, {
      iv: CryptoJS.enc.Utf8.parse(this.Vector),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,

    }).toString();
  }

  decryptIA(encryptedText: string): string {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.secretKey, {
      iv: CryptoJS.enc.Utf8.parse(this.Vector),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,

    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  encryptObject1(value: any): string {

    return CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey, {
      iv: CryptoJS.enc.Utf8.parse(this.Vector),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,

    }).toString();
  }


  //------

  //decrypt(encryptedText: string): string {
  //  const decrypted = CryptoJS.AES.decrypt(encryptedText, this.secretKey, {
  //    iv: CryptoJS.enc.Utf8.parse(this.Vector),
  //    mode: CryptoJS.mode.CBC,
  //    padding: CryptoJS.pad.Pkcs7,

  //  });
  //  return decrypted.toString(CryptoJS.enc.Utf8);
  //}
  //encryptObject(value: any): string {

  //  return CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey, {
  //    iv: CryptoJS.enc.Utf8.parse(this.Vector),
  //    mode: CryptoJS.mode.CBC,
  //    padding: CryptoJS.pad.Pkcs7,

  //  }).toString();
  //}

  ////////////////////////////////////////////////////////////////////////////

  //encryptnew(value: string): string {
  //  const key = CryptoJS.enc.Utf8.parse(this.secretKeynew);
  //  const iv = CryptoJS.enc.Utf8.parse(this.Vectornew);
  //  const encrypted = CryptoJS.AES.encrypt(value, key, {
  //    iv: iv,
  //    mode: CryptoJS.mode.CBC,
  //    padding: CryptoJS.pad.Pkcs7,
  //  });
  //  return encrypted.toString();
  //}

  //decryptnew(encryptedText: string): string {
  //  const key = CryptoJS.enc.Utf8.parse(this.secretKey);
  //  const iv = CryptoJS.enc.Utf8.parse(this.Vector);
  //  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
  //    iv: iv,
  //    mode: CryptoJS.mode.CBC,
  //    padding: CryptoJS.pad.Pkcs7,
  //  });
  //  return decrypted.toString(CryptoJS.enc.Utf8);
  //}




  decryption(encryptedText: string): string {
    try {
      const parts = encryptedText.split(':');
      if (parts.length !== 3) {
        throw new Error('Invalid encrypted text format');
      }

      const salt = parts[0];
      const ivHex = parts[1];
      const encryptedData = parts[2];

      const key = CryptoJS.PBKDF2(this.secretKeynew, CryptoJS.enc.Hex.parse(salt), {
        keySize: 256 / 32,
        iterations: 1000,
        hasher: CryptoJS.algo.SHA256
      });

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: CryptoJS.enc.Hex.parse(ivHex), // Parse the IV from the encrypted text as Hex
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Decryption error:', error);
      return ''; // Or handle the error as needed
    }
  }


}
